import React from 'react'
import { CardTitle as ReactstrapCardTitle, CardTitleProps } from 'reactstrap'

export const CardTitle: React.FC<CardTitleProps> = props => {
  return <ReactstrapCardTitle {...props} />
}
